import React, { useMemo, useRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { accordionStyles } from './styles';
import { Box } from '@mui/material';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const textCenter = {
  id: 'textCenter',
  afterDatasetsDraw(chart, _args, _pluginOptions) {
    const {ctx, data, chartArea: { left }, scales: { y }} = chart;
    
    data.datasets[0].data.forEach((dataPoint, index) => {
      ctx.font = 'bolder 1.6em sans-serif';
      ctx.fillStyle = 'black';
      ctx.textBaseline = 'middle';
			ctx.fillText(dataPoint.x?.toFixed(1) + '%', left + 20, y.getPixelForValue(index))
    })
    
    ctx.save();
  }
}

const options = {
  indexAxis: 'y',
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  barThickness: 40,
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        afterTitle: (ctx) => `Ultima conexión: ${ctx[0].raw.text}`
      }
    }
  },
};


export const HorizontalBarChar = React.memo((props) => {
  const { registers: units } = props.saveHandlers
  const backgroundColor = useMemo(() => units.map(unit => unit.connection ? 'rgba(0, 85, 170, 0.6)' : 'rgba(246,104,94,0.6)'), [units])
  const classes = accordionStyles();
  const chartRef = useRef(null);
  const labels = useMemo(() => units.map(unit => unit.name), [units]);
  
  let height = 400
  if(labels.length > 6) height = height + ((labels.length - 6) * 66.66)

  const data = useMemo(() => ({
    datasets: [
      {
        label: 'Porcentaje',
        data: units.map(unit => ({x: unit.percentage, y: unit?.name, text: unit?.datetime || unit?.time_stamp, ...unit})),
        borderColor: 'rgba(0, 0, 0, 0)',
        backgroundColor
      },
    ],
  }), [backgroundColor]);

  return <Box className={classes.scrollBox}>
    <Box sx={{height}}>      
      <Bar 
        options={options} 
        data={data} 
        ref={chartRef}
        plugins={[textCenter]}
      />
    </Box>
  </Box>
})
